"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var WaffleIconFocus_exports = {};
__export(WaffleIconFocus_exports, {
  default: () => WaffleIconFocus_default
});
module.exports = __toCommonJS(WaffleIconFocus_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.50293 16.0117C7.76882 16.0117 7.9956 16.1134 8.18328 16.3167C8.38661 16.5044 8.48827 16.7312 8.48827 16.9971V19.0147C8.48827 19.2805 8.38661 19.5152 8.18328 19.7185C7.9956 19.9062 7.76882 20 7.50293 20H5.48534C5.21945 20 4.98485 19.9062 4.78152 19.7185C4.59384 19.5152 4.5 19.2805 4.5 19.0147V16.9971C4.5 16.7312 4.59384 16.5044 4.78152 16.3167C4.98485 16.1134 5.21945 16.0117 5.48534 16.0117H7.50293ZM13.5088 16.0117C13.7747 16.0117 14.0015 16.1134 14.1891 16.3167C14.3925 16.5044 14.4941 16.7312 14.4941 16.9971V19.0147C14.4941 19.2805 14.3925 19.5152 14.1891 19.7185C14.0015 19.9062 13.7747 20 13.5088 20H11.4912C11.2253 20 10.9907 19.9062 10.7874 19.7185C10.5997 19.5152 10.5059 19.2805 10.5059 19.0147V16.9971C10.5059 16.7312 10.5997 16.5044 10.7874 16.3167C10.9907 16.1134 11.2253 16.0117 11.4912 16.0117H13.5088ZM19.5147 16.0117C19.7805 16.0117 20.0073 16.1134 20.195 16.3167C20.3983 16.5044 20.5 16.7312 20.5 16.9971V19.0147C20.5 19.2805 20.3983 19.5152 20.195 19.7185C20.0073 19.9062 19.7805 20 19.5147 20H17.4971C17.2312 20 16.9966 19.9062 16.7933 19.7185C16.6056 19.5152 16.5117 19.2805 16.5117 19.0147V16.9971C16.5117 16.7312 16.6056 16.5044 16.7933 16.3167C16.9966 16.1134 17.2312 16.0117 17.4971 16.0117H19.5147ZM7.50293 10.0059C7.76882 10.0059 7.9956 10.1075 8.18328 10.3109C8.38661 10.4985 8.48827 10.7253 8.48827 10.9912V13.0088C8.48827 13.2747 8.38661 13.5093 8.18328 13.7126C7.9956 13.9003 7.76882 13.9941 7.50293 13.9941H5.48534C5.21945 13.9941 4.98485 13.9003 4.78152 13.7126C4.59384 13.5093 4.5 13.2747 4.5 13.0088V10.9912C4.5 10.7253 4.59384 10.4985 4.78152 10.3109C4.98485 10.1075 5.21945 10.0059 5.48534 10.0059H7.50293ZM13.5088 10.0059C13.7747 10.0059 14.0015 10.1075 14.1891 10.3109C14.3925 10.4985 14.4941 10.7253 14.4941 10.9912V13.0088C14.4941 13.2747 14.3925 13.5093 14.1891 13.7126C14.0015 13.9003 13.7747 13.9941 13.5088 13.9941H11.4912C11.2253 13.9941 10.9907 13.9003 10.7874 13.7126C10.5997 13.5093 10.5059 13.2747 10.5059 13.0088V10.9912C10.5059 10.7253 10.5997 10.4985 10.7874 10.3109C10.9907 10.1075 11.2253 10.0059 11.4912 10.0059H13.5088ZM19.5147 10.0059C19.7805 10.0059 20.0073 10.1075 20.195 10.3109C20.3983 10.4985 20.5 10.7253 20.5 10.9912V13.0088C20.5 13.2747 20.3983 13.5093 20.195 13.7126C20.0073 13.9003 19.7805 13.9941 19.5147 13.9941H17.4971C17.2312 13.9941 16.9966 13.9003 16.7933 13.7126C16.6056 13.5093 16.5117 13.2747 16.5117 13.0088V10.9912C16.5117 10.7253 16.6056 10.4985 16.7933 10.3109C16.9966 10.1075 17.2312 10.0059 17.4971 10.0059H19.5147ZM7.50293 4C7.76882 4 7.9956 4.10166 8.18328 4.30499C8.38661 4.49267 8.48827 4.71945 8.48827 4.98534V7.00293C8.48827 7.26882 8.38661 7.50342 8.18328 7.70674C7.9956 7.89443 7.76882 7.98827 7.50293 7.98827H5.48534C5.21945 7.98827 4.98485 7.89443 4.78152 7.70674C4.59384 7.50342 4.5 7.26882 4.5 7.00293V4.98534C4.5 4.71945 4.59384 4.49267 4.78152 4.30499C4.98485 4.10166 5.21945 4 5.48534 4H7.50293ZM13.5088 4C13.7747 4 14.0015 4.10166 14.1891 4.30499C14.3925 4.49267 14.4941 4.71945 14.4941 4.98534V7.00293C14.4941 7.26882 14.3925 7.50342 14.1891 7.70674C14.0015 7.89443 13.7747 7.98827 13.5088 7.98827H11.4912C11.2253 7.98827 10.9907 7.89443 10.7874 7.70674C10.5997 7.50342 10.5059 7.26882 10.5059 7.00293V4.98534C10.5059 4.71945 10.5997 4.49267 10.7874 4.30499C10.9907 4.10166 11.2253 4 11.4912 4H13.5088ZM19.5147 4C19.7805 4 20.0073 4.10166 20.195 4.30499C20.3983 4.49267 20.5 4.71945 20.5 4.98534V7.00293C20.5 7.26882 20.3983 7.50342 20.195 7.70674C20.0073 7.89443 19.7805 7.98827 19.5147 7.98827H17.4971C17.2312 7.98827 16.9966 7.89443 16.7933 7.70674C16.6056 7.50342 16.5117 7.26882 16.5117 7.00293V4.98534C16.5117 4.71945 16.6056 4.49267 16.7933 4.30499C16.9966 4.10166 17.2312 4 17.4971 4H19.5147Z",
      fill: "currentColor"
    }
  )
);
const SvgWaffleIconFocus = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var WaffleIconFocus_default = SvgWaffleIconFocus;
